import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-environment-banner',
  templateUrl: './environment-banner.html',
  styleUrl: './environment-banner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnvironmentBannerComponent {
  protected readonly name: string | null = environment.environmentName?.trim() || null;

  protected readonly slug: string = (this.name ?? '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
}
